/** Page sizes for admin lists: 5, 10, 15, … up to max (step 5). */
export const PAGE_SIZE_STEP = 5;
export const PAGE_SIZE_MAX = 100;

export const PAGE_SIZE_OPTIONS = Array.from(
  { length: PAGE_SIZE_MAX / PAGE_SIZE_STEP },
  (_, i) => (i + 1) * PAGE_SIZE_STEP,
);

export const DEFAULT_PAGE_SIZE = 50;
